export class Tracking
{
    public leadID: string;
    public currentPageName:string;
    public previousPageName:string;
    public dateCreated: Date;
    public dateUpdated?: Date;
    public inProgress?: boolean;

}